import { render } from "./MovieCard.vue?vue&type=template&id=229d0c2c"
import script from "./MovieCard.vue?vue&type=script&lang=js"
export * from "./MovieCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/amir/Desktop/movie-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__